<template>
  <p>Labels</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>